/**
 * Created by Administrador on 13/09/2017.
 */
(function(){
    'use strict';

    angular
        .module('completeAir')
        .factory('transferPassengerService', transferPassengerService);

    transferPassengerService.$inject = ['$http', 'CONFIG', 'messageService'];

    function transferPassengerService($http, CONFIG, messageService){
        var urlBase = CONFIG.API_URL + '/' + CONFIG.API_PNR + '/' + CONFIG.API + '/pnr';
        var service = {
            getPNRs: getPNRs,
            getCheckInPNRs: getCheckInPNRs,
            getPNR: getPNR,
            getPNRById: getPNRById,
            updateChangeFlightPnr: updateChangeFlightPnr,
            updateTransferLuggage: updateTransferLuggage
        }

        return service;

        function getPNRs(segmentFlightId,page,size){
            return $http.get(urlBase +"/search/pnr/" + segmentFlightId + "/passengers?transfer=true&page=" + page + '&size=' + size)
                .then(function(response){
                    return (response.data._embedded) ? response.data._embedded.pnrs : [];
                })
                .catch(function(){
                    messageService.findAllError('');
                });
        }

        function getCheckInPNRs(segmentFlightId,page,size){
            return $http.get(urlBase +"/search/pnr/" + segmentFlightId + "/passengers?checkIn=true&page=" + page + '&size=' + size)
                .then(function(response){
                    return (response.data._embedded) ? response.data._embedded.pnrs : [];
                })
                .catch(function(){
                    messageService.findAllError('');
                });
        }

        function getPNR(pnrCode){
            return $http.get(urlBase +"?pnrCode=" + pnrCode)
                .then(function(response){
                    return (response.data) ? response.data : {};
                })
                .catch(function(){
                    messageService.findAllError('');
                });
        }

        function getPNRById(pnrId){
            return $http.get(urlBase +"/PNR/" + pnrId)
                .then(function(response){
                    return (response.data) ? response.data : {};
                })
                .catch(function(){
                    messageService.findAllError('');
                });
        }

        function updateChangeFlightPnr(operationSale, userLogin,status){
            return $http.put(urlBase + "/flight?user_login=" + userLogin, operationSale)
                .then(function(response){
                    if(status!=='CHECKED'){
                        messageService.registerUpdate('')
                    }
                    return "ok";
                })
                .catch(function(error){
                    messageService.findAllError('');
                    return "error"
                });
        }

        function updateTransferLuggage(pnrCode, oldSegmentFlightId, newSegmentFlightId, userLogin){
            return $http.put(urlBase + "/transfer/luggage/"+pnrCode+"?oldSegmentFlightId="+oldSegmentFlightId+"&newSegmentFlightId="+newSegmentFlightId+"&user_login=" + userLogin)
                .then(function(response){
                    messageService.registerUpdate('')
                    return response;
                })
                .catch(function(error){
                    messageService.findAllError('');
                });
        }
    };
})();
